import script from "./KeyPoints.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeyPoints.vue?vue&type=script&setup=true&lang=ts"

import "./KeyPoints.vue?vue&type=style&index=0&id=268593d0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-268593d0"]])

export default __exports__